import Vue from 'vue'
// Lib imports
import axios from 'axios'
var production = true
Vue.prototype.$app_mode = "Production"
var SERVER = "http://localhost:9002"
if(production) {
  if(Vue.prototype.$app_mode == "Production")
    SERVER = "https://srv.playbet247.net"
  else if(Vue.prototype.$app_mode == "Development")
        SERVER = "http://localhost:9595"
}
Vue.prototype.$http = axios.create({
  baseURL: SERVER + '/api/'
})

Vue.prototype.$fileserver = SERVER + '/public/'